import { RemoteBrandLogo28 } from 'remote-com-shared/components/Brand/Logo';
import { FooterContainer, FooterBottom } from 'remote-com-shared/components/Footer/styles';
import styled from 'styled-components';

const FooterBottomWrapper = styled(FooterBottom)`
  border: none;
  align-items: center;
  gap: 50px;
`;

const Links = styled.div`
  display: flex;
  gap: 53px;
  flex-wrap: wrap;
`;

const Link = styled.a`
  ${({ theme }) => theme.typography.bodySMMedium}
  color: var(--colors-blank);
  text-transform: uppercase;

  &:hover {
    text-decoration: underline;
  }
`;

const FooterContainerWrapper = styled(FooterContainer)`
  padding-top: 0;
`;

const EmploymentFAQFooter = () => (
  <FooterContainerWrapper>
    <FooterBottomWrapper>
      <RemoteBrandLogo28 />

      <Links>
        <Link href={`${process.env.NEXT_PUBLIC_PANDA_BASE_URL}/privacy-policy`}>Privacy</Link>
        <Link href={`${process.env.NEXT_PUBLIC_PANDA_BASE_URL}/terms-of-use`}>Terms of use</Link>
      </Links>
    </FooterBottomWrapper>
  </FooterContainerWrapper>
);

export default EmploymentFAQFooter;
